import api from './api';

// Публичный просмотр успеваемости ученика по коду (без авторизации)
export const getProgressByCode = (code) => api.get(`/public/progress/${encodeURIComponent(code)}`);

// Полная карточка ученика по коду — та же, что открывает админ в «Учениках»
export const getOverviewByCode = (code) => api.get(`/public/overview/${encodeURIComponent(code)}`);
